import { render, staticRenderFns } from "./GallerySwiper.vue?vue&type=template&id=08fd8b19&"
import script from "./GallerySwiper.vue?vue&type=script&lang=js&"
export * from "./GallerySwiper.vue?vue&type=script&lang=js&"
import style0 from "./GallerySwiper.vue?vue&type=style&index=0&id=08fd8b19&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports